import { useEffect, useRef } from 'react'

import { useFormikContext, FormikValues } from 'formik'

type DataType<T> = {
    next: T
    prev: T
}

type Props<T> = {
    onChange: (data: DataType<T>) => void
}

export const FormObserver = <T extends FormikValues>({ onChange }: Props<T>) => {
    const { values } = useFormikContext()
    const prevValues = useRef(values)

    useEffect(() => {
        onChange({ next: values as T, prev: prevValues.current as T })

        prevValues.current = values
    }, [values, onChange])

    return null
}
